import React, { useState } from "react";
import clsx from "clsx";

import CareerSheetTable from "./CareerSheetTable";
import CareerChallengeSheetTable from "./CareerChallengeSheetTable";
import CareerQuestionTable from "./CareerQuestionTable";
import styles from "./CareerAnswerHistory.module.scss";

type TabKey = "career_sheet" | "career_challenge_sheet" | "career_question";

const TABS: { key: TabKey; label: string }[] = [
  { key: "career_sheet", label: "キャリア開拓シート" },
  { key: "career_challenge_sheet", label: "進路決定チャレンジシート" },
  { key: "career_question", label: "キャリア開拓クエスチョン" },
];

const CareerAnswerHistory = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("career_sheet");

  return (
    <div className={styles.wrapper}>
      <div className={styles.tab}>
        <div className={styles.tabList}>
          {TABS.map(tab => (
            <div
              key={tab.key}
              className={clsx(
                styles.tabItem,
                activeTab === tab.key && styles.isActive,
              )}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.container}>
        {activeTab === "career_sheet" && <CareerSheetTable />}
        {activeTab === "career_challenge_sheet" && (
          <CareerChallengeSheetTable />
        )}
        {activeTab === "career_question" && <CareerQuestionTable />}
      </div>
    </div>
  );
};

export default CareerAnswerHistory;
